import { PolicyPage } from '../components/PolicyRenderer'
import { privacyContent } from './privacyContent'
import PageMeta from '../components/PageMeta'

export default function PrivacyPolicy() {
    return <>
        <PageMeta
            title="Privacy Policy"
            description="Contract Finder Pro privacy policy. How we collect, use and protect your personal data in accordance with UK GDPR."
            canonical="/privacy"
        />
        <PolicyPage content={privacyContent} />
    </>
}
